import { useProductForm } from "@/hooks/products/useProductForm";
import type { ProductResponse } from "@/infrastructure/services/productService";
import { Button, Icon, Loading } from "@uigovpe/components";
import { useNavigate } from "react-router-dom";
import type { ProductFormMode, ProductFormValues } from "../types";
import ProductForm from "./product-form";

type Props = {
  onValuesChange: (values: ProductFormValues) => void;
  onCategoriesLoadingChange?: (loading: boolean) => void;
  mode?: ProductFormMode;
  productId?: number;
  initialValues?: ProductFormValues;
  initialProduct?: ProductResponse;
};

export default function ProductFormCard({
  onValuesChange,
  onCategoriesLoadingChange,
  mode = "create",
  productId,
  initialValues,
  initialProduct,
}: Props) {
  const { isSubmitting, methods, submit, submitIntent } = useProductForm({
    mode,
    productId,
    initialValues,
    initialProduct,
  });
  const navigate = useNavigate();
  const primaryLabel =
    submitIntent === "publish"
      ? mode === "edit"
        ? "Atualizando..."
        : "Publicando..."
      : mode === "edit"
        ? "Atualizar produto"
        : "Publicar produto";
  return (
    <div className="relative! flex! flex-col! gap-6!" aria-busy={isSubmitting}>
      {submitIntent && (
        <div
          className="absolute! inset-0! z-50! flex! items-center! justify-center! rounded-sm! bg-white/75! backdrop-blur-[1px]!"
          role="status"
          aria-live="polite"
        >
          <Loading />
          <span className="sr-only">Processando produto...</span>
        </div>
      )}
      <h1 className="m-0! text-3xl! font-bold! text-zinc-800!">
        {mode === "edit" ? "Editar Produto" : "Cadastro de Produto"}
      </h1>
      <div className="rounded-sm! border! border-zinc-200! bg-background! px-4! py-5! shadow-sm! md:px-10!">
        <div className="mb-10! flex! w-full! flex-col! md:mb-12!">
          <ProductForm
            methods={methods}
            onSubmit={submit}
            onValuesChange={onValuesChange}
            onCategoriesLoadingChange={onCategoriesLoadingChange}
          />
        </div>
        <div className="flex! flex-col-reverse! gap-4! sm:flex-row! sm:flex-wrap! sm:justify-end!">
          <Button
            label="Voltar"
            type="button"
            disabled={isSubmitting}
            onClick={() => navigate(-1)}
            className="secondary-action-button"
            icon={
              <Icon icon="arrow_left_alt" outline className="text-[#4e3873]!" />
            }
            outlined
          />
          <Button
            label={submitIntent === "draft" ? "Salvando..." : "Salvar Rascunho"}
            type="submit"
            form="product-form"
            name="intent"
            value="draft"
            loading={submitIntent === "draft"}
            disabled={isSubmitting}
            className="secondary-action-button"
            icon={<Icon icon="save" outline className="text-[#4e3873]!" />}
            outlined
          />
          <Button
            label={primaryLabel}
            type="submit"
            form="product-form"
            name="intent"
            value="publish"
            className="text-white!"
            loading={submitIntent === "publish"}
            disabled={isSubmitting}
            icon={
              <Icon icon="arrow_right_alt" className="text-white!" outline />
            }
          />
        </div>
      </div>
    </div>
  );
}
